'use strict';

import { combinereducers } from 'redux';
import update from 'immutability-helper';
import * as types from './types';
import * as jTypes from '@/state/domains/orders/types';

export default (
    state = [],
	action
) => {

    switch (action.type) {

		case jTypes.GET_JOBS_COMPLETED:
			return action.data.jobs.map(j => j._id);

		default:
			return state;
	}
};
